import React, {
  useMemo, createContext, useState, useEffect,
} from 'react'

const SelectedItemsContext = createContext([])

const SelectItemsContextProvider = ({ children }) => {
  const [orderItems, setOrderItems] = useState([])
  const [applicationData, setApplicationData] = useState(null)
  const [successData, setSuccessData] = useState([])
  const [selectedImages, setSelectedImages] = useState({})
  const [selectedDocs, setSelectedDocs] = useState({})
  const [filesUpload, setFilesUpload] = useState({})

  const contextValue = useMemo(
    () => ({
      orderItems,
      setOrderItems,
      applicationData,
      setApplicationData,
      successData,
      setSuccessData,
      selectedImages,
      setSelectedImages,
      selectedDocs,
      setSelectedDocs,
      filesUpload,
      setFilesUpload,
    }),
    [
      orderItems,
      setOrderItems,
      applicationData,
      setApplicationData,
      successData,
      setSuccessData,
      selectedImages,
      setSelectedImages,
      selectedDocs,
      setSelectedDocs,
      filesUpload,
      setFilesUpload,
    ],
  )

  return (
    <SelectedItemsContext.Provider value={contextValue}>
      {children}
    </SelectedItemsContext.Provider>
  )
}

export { SelectedItemsContext }
export default SelectItemsContextProvider
